module.exports = __webpack_public_path__ + "static/media/EW_0013_02.b7c435b3.png";